/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md: exports a hook, not a component. */
import { type RefObject, useEffect } from 'react';

const INERT_WRAPPER_SELECTOR = '[aria-roledescription="draggable"][aria-disabled="true"]';

export function useInertDraggableWrappers(
  rootRef: RefObject<HTMLElement | null>,
  enabled: boolean,
) {
  useEffect(() => {
    const root = rootRef.current;
    if (!enabled || !root) return;
    // ilamy keeps a focusable role=button wrapper on every item even with drag disabled, nesting the item's own link.
    const strip = () => {
      for (const wrapper of root.querySelectorAll(INERT_WRAPPER_SELECTOR)) {
        wrapper.removeAttribute('role');
        wrapper.removeAttribute('tabindex');
        wrapper.removeAttribute('aria-roledescription');
      }
    };
    strip();
    const observer = new MutationObserver(strip);
    observer.observe(root, { childList: true, subtree: true, attributes: true });
    return () => observer.disconnect();
  }, [rootRef, enabled]);
}
